import React, { useEffect, useState } from 'react';
import { participate } from '../api/groupFlow';
import './PostListPage.css';
import { API_BASE_URL } from '../api/config';


function PostListPage({
  onCreatePost,
  onOpenChatRooms,
  onOpenProfile,
  onEnterChatRoom,
  onViewProfile,
  username,
  nickname,
}) {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const loadPosts = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/api/posts`)
      .then((res) => res.json())
      .then((data) => setPosts(Array.isArray(data) ? data : []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadPosts();
  }, []);

  const handleParticipate = async (groupId, title) => {
    setError('');
    try {
      if (!username) {
        setError('로그인이 필요합니다.');
        return;
      }
      const result = await participate(groupId, username);
      if (result && result.chatRoomId) {
        onEnterChatRoom?.(result.chatRoomId, title || result.chatRoomName || '');
      } else {
        setError('채팅방 정보를 받지 못했습니다.');
      }
    } catch (e) {
      setError(e.message || '참여에 실패했습니다.');
    }
  };

  const handleDelete = async (postId, author) => {
    if (!window.confirm('정말 삭제하시겠습니까?')) return;
    setError('');
    try {
      const res = await fetch(
        `${API_BASE_URL}/api/posts/${postId}?author=${encodeURIComponent(author)}`,
        { method: 'DELETE' }
      );
      const data = await res.json().catch(() => ({}));
      if (!res.ok && data.error) {
        setError(data.error);
      } else {
        loadPosts();
      }
    } catch (e) {
      setError('삭제에 실패했습니다.');
    }
  };

  return (
    <div className="app-shell postlist-page">
      <aside className="app-sidebar">
        <img src="/images/logoTextWhite.png" alt="공구나라" className="app-sidebar-logo" />
        <nav className="app-sidebar-nav">
          <button type="button" className="app-nav-btn" onClick={onOpenChatRooms}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white" aria-hidden="true">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
            </svg>
            <span>내 채팅방</span>
          </button>
          <button type="button" className="app-nav-btn" onClick={onOpenProfile}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white" aria-hidden="true">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
            <span>내 프로필</span>
          </button>
        </nav>
      </aside>

      <main className="app-main">
        <div className="app-card postlist-card">
          <div className="postlist-toolbar">
            <p className="postlist-greeting">
              안녕하세요, <strong>{nickname || username}</strong> 님
            </p>
            <button type="button" className="app-btn" onClick={onCreatePost}>
              게시물 생성
            </button>
          </div>

          <div className="app-card-header">
            <h2 className="app-card-title">게시물 목록</h2>
          </div>

          <div className="app-card-body postlist-body">
            {loading && <div className="app-empty">불러오는 중…</div>}

            {!loading && posts.length === 0 && (
              <div className="app-empty">아직 게시물이 없어요. 첫 공구를 만들어 보세요.</div>
            )}

            {!loading && posts.length > 0 && (
              <ul className="post-list">
                {posts.map((post) => {
                  const isMine =
                    String(post.author || '').trim().toLowerCase() ===
                    String(username || '').trim().toLowerCase();
                  return (
                    <li key={post.id} className="post-item">
                      <div className="post-thumb-wrap">
                        {post.attachment ? (
                          <img
                            src={post.attachment}
                            alt=""
                            className="post-thumb"
                            onError={(e) => {
                              e.currentTarget.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div className="post-thumb placeholder">공구</div>
                        )}
                      </div>

                      <div className="post-content">
                        <div className="post-title-row">
                          <h3 className="post-title">{post.title}</h3>
                          <span className="post-price">
                            {Number(post.priceCents || 0).toLocaleString()}원
                          </span>
                        </div>
                        <div className="post-meta">
                          <button
                            type="button"
                            className="post-author"
                            onClick={() => onViewProfile?.(post.author)}
                          >
                            {post.authorNickname || post.author}
                          </button>
                          {post.headcount != null && (
                            <span className="post-count">
                              {post.currentParticipants || 0}/{post.headcount}명
                            </span>
                          )}
                        </div>
                        {(post.startDate || post.endDate) && (
                          <div className="post-date">
                            {post.startDate && post.endDate
                              ? `${post.startDate} ~ ${post.endDate}`
                              : post.startDate || post.endDate}
                          </div>
                        )}
                      </div>

                      <div className="post-actions">
                        {!isMine && (
                          <button
                            type="button"
                            className="app-btn"
                            onClick={() => handleParticipate(post.groupId || post.id, post.title)}
                          >
                            참여
                          </button>
                        )}
                        {isMine && (
                          <button
                            type="button"
                            className="app-btn secondary"
                            onClick={() => handleDelete(post.id, username)}
                          >
                            삭제
                          </button>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}

            {error && <div className="app-error">{error}</div>}
          </div>
        </div>
      </main>
    </div>
  );
}

export default PostListPage;
